import React from 'react';
import cn from 'clsx';
import { Icon } from '../icon';
import { InformationIconProps } from '@components-clean/core/icons/information-icon/information-icon.interface';

const InformationIcon = ({ title, dataTestId, className, tooltipPosition, maxWidth }: InformationIconProps) => {
    return (
        <Icon
            dataTestId={dataTestId}
            className={cn(className)}
            title={title}
            icon={['fal', 'info-circle']}
            tooltipPosition={tooltipPosition}
            maxWidth={maxWidth}
        />
    );
};

export default InformationIcon;
